module.exports = __webpack_public_path__ + "img/phone.3e47f6ee.svg";